import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { contractGenerationClassConfig } from './ContractGenerationClass.name';

/** 約定発生区分のENUM */
enum ContractGenerationClass {
  /** 約定 */
  agreement = '1',
  /** 発生 */
  occurrence = '2',
  /** 発生(年) */
  occurrenceYear = '3',
  /** 約定(利息発生) */
  agreementInterestOccurrence = '4',
}

const contractGenerationClassMap = new Map([
  ['1', ContractGenerationClass.agreement],
  ['2', ContractGenerationClass.occurrence],
  ['3', ContractGenerationClass.occurrenceYear],
  ['4', ContractGenerationClass.agreementInterestOccurrence],
]);

const rawValueToContractGenerationClass = rawValueToEnumWithDefault(contractGenerationClassMap, '');

const contractGenerationClassToDisplay = enumToNameWithDefault(
  ContractGenerationClass,
  contractGenerationClassConfig,
);

const contractGenerationClassToDisplayWithPrefix = enumToNameWithDefault(
  ContractGenerationClass,
  contractGenerationClassConfig,
  true,
);

export {
  ContractGenerationClass,
  contractGenerationClassToDisplay,
  contractGenerationClassToDisplayWithPrefix,
  rawValueToContractGenerationClass,
};
